import AboutHK from '@/page/aboutHK/index.vue'
import News from '@/page/hk/news.vue'
import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    redirect:'/aboutHK/introduce'
  },
  {
    path: '/home',
    name: 'home',
    component: Index,
  },
  {
    path: '/hk_index',
    name: 'hkindex',
    component: () => import('../views/hk/index.vue')
  },
  {
    path: '/aboutHK',
    component: AboutHK,
    redirect: '/aboutHK/introduce',
    children: [{
      path: "/aboutHK/introduce",
      name: '公司介绍',
      component: () =>
        import( '@/views/aboutHK/introduce.vue'),
        meta: {
          title: '关于华科-公司介绍'
        }
    },
    {
      path: "/aboutHK/enterpriseCul",
      name: '企业文化',
      component: () =>
        import( '@/views/aboutHK/enterpriseCul.vue'),
        meta: {
          title: '关于华科-企业文化'
        }
    },
    {
      path: "/aboutHK/events",
      name: '大事记',
      component: () =>
        import( '@/views/aboutHK/events.vue'),
        meta: {
          title: '关于华科-大事记'
        }
    },
    {
      path: "/aboutHK/case",
      name: '经典案例',
      component: () =>
        import( '@/views/aboutHK/case.vue'),
        meta: {
          title: '关于华科-经典案例'
        }
    },
    {
      path: "/aboutHK/social",
      name: '社会职务',
      component: () =>
        import( '@/views/aboutHK/social.vue'),
        meta: {
          title: '关于华科-社会荣誉'
        }
    },
  ]
  },
  {
    path: '/business',
    name: 'business',
    component: () => import('../views/hk/business_new.vue'),
    meta: {
      title: '华科金融-业务领域'
    }
  },
  {
    path: '/news',
    name: 'news',
    component: News,
    redirect: '/news/index',
    children: [
      {
        path: "/news/index",
        name: '',
        component: () =>
          import( '@/views/hk/news.vue'),
          meta: {
          title: '华科金融-新闻资讯'
        }
      },
      {
        path: "/news/detailqyold",
        name: '',
        component: () =>
          import( '@/views/hk/detail_qy.vue'),
        meta: {
          title: '华科金融-新闻详情'
        }
      },
      {
        path: "/news/detailhyold",
        name: '',
        component: () =>
          import( '@/views/hk/detail_hy.vue'),
        meta: {
          title: '华科金融-新闻详情'
        }
      },
      
    ],
  },
  {
    path: '/news/detailqy',
    name: 'detailqy',
    component: () =>
      import( '@/views/hk/detail_qy.vue'),
    meta: {
      title: '华科金融-新闻详情'
    }
  },
  {
    path: '/news/detailhy',
    name: 'detailhy',
    component: () =>
      import( '@/views/hk/detail_qy.vue'),
    meta: {
      title: '华科金融-新闻详情'
    }
  },
  {
    path: '/digitization',
    name: 'digitization',
    component: () => import(/* webpackChunkName: "digitization" */ '../views/hk/digitization.vue'),
    meta: {
      title: '华科金融-数字金融'
    }
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: () => import('../views/hk/contactUs.vue'),
    meta: {
      title: '华科金融-联系我们'
    }
  },
  // 基金公司
  {
    path: '/fundcompany',
    name: 'fundCompany',
    component: () => import('../views/fundCompany/index.vue'),
    meta: {
      title: '华科产融'
    }
  },
  // 新数软
  {
    path: '/newSR',
    name: 'newSR',
    component: () => import('../views/newSR/index.vue'),
    meta: {
      title: '新数软'
    }
  },
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
